import React from 'react';

import { Icon } from 'b3';
import FergusLogo from '../../FergusLogo';
import TimelineItem from './TimelineItem';

export default function UservoiceQueryTimelineItem(props) {
	var icon 	= <Icon icon="volume-loud-1" />;
	var avatar = <FergusLogo className="avatar" />;
    var typeLabel = <span>Uservoice<br/>Query</span>;

    var isLongContent = (props.query.length > 230);

    return (
        <TimelineItem
        	type="uservoicequery"
            typeLabel={typeLabel}
        	avatar={avatar}
        	icon={icon}
            isLongContent={isLongContent}
        >
        	<span className="taskSpan" dangerouslySetInnerHTML={{__html: props.query}}></span>
        </TimelineItem>
    );
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/UservoiceQueryTimelineItem.js